import apiClient from './config';

export default {
  // ===== PROFIL UTILISATEUR =====

  // Récupérer le profil de l'utilisateur
  getUserProfile() {
    return apiClient.get('/admin/profile');
  },

  // Mettre à jour le profil utilisateur
  updateUserProfile(data) {
    return apiClient.put('/admin/profile', data);
  },

  // ===== ÉTABLISSEMENT =====

  // Récupérer les informations de l'établissement
  getSalonInfo() {
    return apiClient.get('/firm/info');
  },

  // Mettre à jour les informations de l'établissement
  updateSalonInfo(data) {
    return apiClient.put('/firm/info', data);
  },

  // Récupérer les paramètres complets de la firme
  getFirmSettings() {
    return apiClient.get('/firm/info');
  },

// Mettre à jour les paramètres complets de la firme
  updateFirmSettings(data) {
    // Envoyer toutes les données au endpoint unifié
    const payload = {
      nom_societe: data.nomEnseigne,
      adresse: data.adresse,
      ville: data.ville,
      siret: data.siret,
      telephone: data.telephonePublic,
      horaires: data.horaires,
      description: data.description,
      image: data.image,
      photos: data.photos,
      vacances: data.vacances,
      
      // ✅ AJOUTS : On fait passer les paramètres SMS à travers le filtre
      sms_confirmation_enabled: data.sms_confirmation_enabled,
      sms_rappel_enabled: data.sms_rappel_enabled,
      sms_annulation_enabled: data.sms_annulation_enabled,

      prepaiement_active: data.prepaiement_active,
      acompte_demande_par_defaut: data.acompte_demande_par_defaut,
      prepaiement_optionnel: data.prepaiement_optionnel,

    };

    // Nettoyer les valeurs undefined
    Object.keys(payload).forEach(key => {
      if (payload[key] === undefined) {
        delete payload[key];
      }
    });

    return apiClient.put('/settings/firm-settings', payload);
  },
  // Mettre à jour uniquement les horaires de la firme
  updateFirmSchedule(horaires) {
    return apiClient.put('/firm/horaires', { horaires });
  },

  // Uploader le logo
  uploadLogo(file) {
    const formData = new FormData();
    formData.append('logo', file);
    return apiClient.post('/firm/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Uploader la photo de profil
  uploadProfilePhoto(file) {
    const formData = new FormData();
    formData.append('image', file);
    return apiClient.post('/settings/upload-profile-photo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // ===== STRIPE =====

  // Récupérer le lien vers le portail Stripe
  getStripePortalLink() {
    return apiClient.get('/firm/stripe/portal');
  },

  // Récupérer les informations d'abonnement
  getSubscriptionInfo() {
    return apiClient.get('/firm/stripe/subscription');
  },

  // Créer un compte Stripe Connect pour recevoir les paiements
  createStripeAccount() {
    return apiClient.post('/firm/create-stripe-account');
  },

  // ===== SMS =====

  // Acheter des crédits SMS
  buySMSCredits(data) {
    return apiClient.post('/firm/sms/buy-credits', data);
  },

  // Récupérer les paramètres SMS
  getSMSSettings() {
    return apiClient.get('/firm/sms/settings');
  },

  // Mettre à jour les paramètres SMS
  updateSMSSettings(data) {
    return apiClient.put('/firm/sms/settings', data);
  },

  // Récupérer le solde SMS
  getSMSBalance() {
    return apiClient.get('/firm/sms-credits/balance');
  },
 
  // ===== SÉCURITÉ =====

  // Changer le mot de passe
  changePassword(data) {
    return apiClient.put('/admin/change-password', data);
  },

  // Activer l'authentification à deux facteurs
  enable2FA() {
    return apiClient.post('/admin/2fa/enable');
  },

  // Désactiver l'authentification à deux facteurs
  disable2FA() {
    return apiClient.post('/admin/2fa/disable');
  },

  // ===== NOTIFICATIONS =====

  // Récupérer les paramètres de notification
  getNotificationSettings() {
    return apiClient.get('/admin/notifications/settings');
  },

  // Mettre à jour les paramètres de notification
  updateNotificationSettings(data) {
    return apiClient.put('/admin/notifications/settings', data);
  },
};
